import { createAction } from "@reduxjs/toolkit";
import { REDUCER_PREFIX } from "./slice";

export const filterResultsRequest = createAction(
    `${REDUCER_PREFIX}/filterResultsRequest`
);

export const getFilterResultsCountRequest = createAction(
    `${REDUCER_PREFIX}/getFilterResultsCountRequest`
);